export default function getLastPathSegment(url) {
  const parts = url.split('/');
  return parts[parts.length - 1];
}
